import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { MemoryService } from '@services/memory/memory.service';
import { DataTableComponent, DataTableEvent } from '../../../../components/data-table/data-table.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SubmenuCreatorComponent } from '../../../../components/submenu-creator/submenu-creator.component';
import { ImportService } from '@services/imports/import.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-composition-app-editor-menu-items',
    templateUrl: './composition-app-editor-menu-items.component.html',
    styleUrls: ['./composition-app-editor-menu-items.component.scss'],
    providers: [ImportService],
    standalone: false
})
export class CompositionAppEditorMenuItemsComponent implements OnInit {

  @Input() appTranslation: any;
  @Input() availableItemsProvider: MemoryService<Models.ImportAssignableMenuItem>;

  @ViewChild('assignedItemsTable') assignedItemsTable: DataTableComponent;

  public columns = [{ prop: 'importTitle' }, { prop: 'title' }];
  public assignedColumns = [{ prop: 'title' }];
  public assignedItems = [];

  constructor(private dialog: MatDialog, private importService: ImportService, private activatedRoute: ActivatedRoute) {
  }

  async ngOnInit() {
    const importers = await this.importService.find(0, 5000, { compositionId: this.activatedRoute.snapshot.params['id'] });
    if (!this.appTranslation?.translation?.items?.length && !!this.appTranslation?.translation?.menuItemIds?.length) {
      this.appTranslation.translation.items = this.appTranslation.translation.menuItemIds;
    }
    this.appTranslation.translation.items.map(item => {
      const importer = importers.data.find(element => {
        return element?.assignableMenuItems?.[0]?.menuItemId === item.toString();
      });
      this.assignedItems.push({ title: importer ? (importer.assignableMenuItems[0].title || importer.detail.title || importer.title) : (item.title || item) });
    });
  }

  public assignItem(event: DataTableEvent): void {
    this.appTranslation.translation.menuItemIds.push(event.row.menuItemId);
    this.appTranslation.translation.items.push(event.row.menuItemId);
    this.assignedItems.push({ title: event.row.title });
    if (this.assignedItemsTable) {
      this.assignedItemsTable.refresh();
    }
  }

  public removeAssignedItem(event: DataTableEvent): void {
    this.appTranslation.translation.menuItemIds.splice(event.index, 1);
    this.appTranslation.translation.items.splice(event.index, 1);
    this.assignedItems.splice(event.index, 1);
    if (this.assignedItemsTable) {
      this.assignedItemsTable.refresh();
    }
  }

  public async editItem(event: DataTableEvent): Promise<any> {
    let dialogRef: MatDialogRef<SubmenuCreatorComponent>;
    const assignedItems = [];
    for (const id of this.appTranslation.translation.items[event.index].menuItemIds) {
      const item = this.availableItemsProvider.db.find(a => {
        return a.menuItemId === id;
      });
      if (item) {
        assignedItems.push(item);
      }
    }
    dialogRef = this.dialog.open(SubmenuCreatorComponent, { width: '75vw', height: '850px', data: { menuitemProvider: this.availableItemsProvider, assignedItems } });
    const subMenuItem = await dialogRef.afterClosed().toPromise();
    if (subMenuItem) {
      this.appTranslation.translation.items[event.index] = subMenuItem;
      this.assignedItems[event.index] = { title: subMenuItem.title };
      if (this.assignedItemsTable) {
        this.assignedItemsTable.refresh();
      }
    }
  }

  public async addSubmenuItem() {
    let dialogRef: MatDialogRef<SubmenuCreatorComponent>;
    dialogRef = this.dialog.open(SubmenuCreatorComponent, { width: '75vw', height: '850px', data: { menuitemProvider: this.availableItemsProvider } });
    const subMenuItem = await dialogRef.afterClosed().toPromise();
    if (subMenuItem) {
      this.appTranslation.translation.items.push(subMenuItem);
      this.assignedItems.push({ title: subMenuItem.title });
      if (this.assignedItemsTable) {
        this.assignedItemsTable.refresh();
      }
    }
  }
}
